import React, { createContext, useContext, useState, useEffect } from 'react';
import { getMe } from '../lib/api';

const AuthContext = createContext(null);

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [trialExpired, setTrialExpired] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem('token');
        const savedUser = localStorage.getItem('user');
        
        if (token && savedUser) {
            setUser(JSON.parse(savedUser));
            getMe()
                .then((res) => {
                    setUser(res.data);
                    localStorage.setItem('user', JSON.stringify(res.data));
                    setTrialExpired(false);
                })
                .catch((err) => {
                    if (err.response && err.response.status === 403 && 
                        err.response.data?.detail?.includes('TRIAL_EXPIRED')) {
                        setTrialExpired(true);
                    } else {
                        logout();
                    }
                })
                .finally(() => setLoading(false));
        } else {
            setLoading(false);
        }
    }, []);

    const login = (token, userData) => {
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(userData));
        setUser(userData);
        setTrialExpired(false);
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setUser(null);
        setTrialExpired(false);
    };

    const hasRole = (roles) => {
        if (!user) return false;
        return roles.includes(user.rol);
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, logout, hasRole, trialExpired, setTrialExpired }}>
            {children}
        </AuthContext.Provider>
    );
};
